/**
 * @desc sn批次处理
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.test.snBatchHandle.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/snBatchHandle`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
